import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Menu,
  Skeleton,
  Stack,
  Typography,
  Divider
} from "@mui/material";
import {
  CreditCard,
  DeleteOutline,
  DirectionsCar,
  Close,
  NotificationsNoneOutlined,
  Inventory2Outlined,
  Person,
  HelpOutline,
  AssignmentTurnedInOutlined,
  WorkspacePremiumOutlined,
  VisibilityOutlined,
  Redeem,
  Campaign,
  ArrowForward
} from "@mui/icons-material";
import ListIcon from "@mui/icons-material/List";
import moment from "moment/moment";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AvtarImage from "../../../assets/images/avtar_placeholder.jpeg";
import {
  DELETE_USER_NOTIFICATIONS,
  GET_DASHBOARD_NOTIFICATION,
  SAVE_TICKETS_SHARED_WITH_SUPERVISOR,
  SAVECONTACTEVENT,
  GET_ANNOUNCEMENTS
} from "../../../constant/Apipath";
import { English } from "../../../constant/EnglishFallback";
import { Getrequestcall } from "../../../request/Getrequest";
import { Postrequestcall } from "../../../request/Postrequest";
import UserUsages from "../../common/UserUsages";
import { setMainNotification } from "../../../redux/actions/actions";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import PostComment from "../../new-community/PostComment";

function NotificationsMenu(props) {
  const { anchorEl, menuView, setMenView } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [userNotification, setUserNotification] = useState([]);
  const [contactInvitations, setContactInvitations] = useState([]);
  const [announcements, setAnnouncements] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [actionLoadingId, setActionLoadingId] = useState(null);
  const [weeklyData, setWeeklyData] = useState([]);
  const [confirmDismissOpen, setConfirmDismissOpen] = useState(false);
  const [pendingDismissIds, setPendingDismissIds] = useState([]);
  const [openPostCommentModalWithSource, setOpenPostCommentModalWithSource] = useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const USERID = loginData?.userInformation?.UserId;

  const {
    TEXT_POINTS_GAINED = English?.NotificationsMenu?.TEXT_POINTS_GAINED,
    TEXT_PROJECTS_ADDED = English?.NotificationsMenu?.TEXT_PROJECTS_ADDED,
    TEXT_PRODUCTS_ADDED = English?.NotificationsMenu?.TEXT_PRODUCTS_ADDED,
    TEXT_QUESTIONS_ANS = English?.NotificationsMenu?.TEXT_QUESTIONS_ANS,
    TEXT_NUMBER_OF_VIEWS_PROFILE = English?.NotificationsMenu?.TEXT_NUMBER_OF_VIEWS_PROFILE,
    TEXT_NOTIFICATIONS = English?.NotificationsMenu?.TEXT_NOTIFICATIONS,
    TEXT_CONTACT_REQUESTS = English?.NotificationsMenu?.TEXT_CONTACT_REQUESTS,
    TEXT_ACCEPT = English?.NotificationsMenu?.TEXT_ACCEPT,
    TEXT_DISMISS = English?.NotificationsMenu?.TEXT_DISMISS,
    TEXT_DISMISS_ALL = English?.NotificationsMenu?.TEXT_DISMISS_ALL,
    TEXT_NO_NOTIFICATIONS = English?.NotificationsMenu?.TEXT_NO_NOTIFICATIONS,
    TEXT_WEEKLY_SUMMARY = English?.NotificationsMenu?.TEXT_WEEKLY_SUMMARY,
    TEXT_BUILDER_BUCKS = English?.NotificationsMenu?.TEXT_BUILDER_BUCKS
  } = multiLanguageData?.NotificationsMenu || {};

  const builderBucksNotifications = useMemo(
    () =>
      userNotification.filter(
        (item) => item?.title === "Earn BuilderBucks" || item?.title === "BuilderBucks"
      ),
    [userNotification]
  );

  const regularNotifications = useMemo(
    () =>
      userNotification.filter(
        (item) => item?.title !== "Earn BuilderBucks" && item?.title !== "BuilderBucks"
      ),
    [userNotification]
  );

  const ticketRequests = useMemo(
    () => regularNotifications.filter((item) => item?.title === "VIEW_TICKET_REQUEST"),
    [regularNotifications]
  );

  const nonTicketRegularNotifications = useMemo(
    () => regularNotifications.filter((item) => item?.title !== "VIEW_TICKET_REQUEST"),
    [regularNotifications]
  );

  const dismissableNotifications = useMemo(
    () =>
      [...builderBucksNotifications, ...nonTicketRegularNotifications].filter(
        (item) => Number(item?.userNotificationsDismissalId) !== 0
      ),
    [builderBucksNotifications, nonTicketRegularNotifications]
  );

  const dismissableNotificationIds = useMemo(
    () => [
      ...new Set(
        dismissableNotifications
          .map((item) => Number(item?.userNotificationsDismissalId))
          .filter(Boolean)
      )
    ],
    [dismissableNotifications]
  );

  const hasDismissableNotifications = dismissableNotificationIds.length > 0;
  const isDismissingAll = actionLoadingId === "all";

  const openDismissConfirmation = (ids) => {
    const normalizedIds = [
      ...new Set((ids || []).map((id) => Number(id)).filter((id) => id !== 0))
    ];
    if (!normalizedIds.length) return;
    setPendingDismissIds(normalizedIds);
    setConfirmDismissOpen(true);
  };

  const closeDismissConfirmation = () => {
    if (actionLoadingId) return;
    setConfirmDismissOpen(false);
    setPendingDismissIds([]);
  };

  const confirmDismissNotifications = async () => {
    if (!pendingDismissIds.length) return;
    const idsToDelete = pendingDismissIds;
    setConfirmDismissOpen(false);
    setPendingDismissIds([]);
    await dismissNotifications(idsToDelete);
  };

  const getData = async (showLoading = true) => {
    try {
      if (showLoading) setIsLoading(true);
      UserUsages("DashboardNotifications", loginData);
      
      const announcementsPromise = Getrequestcall(
        GET_ANNOUNCEMENTS,
        loginData?.accessToken
      );

      const notificationsPromise = Getrequestcall(
        `${GET_DASHBOARD_NOTIFICATION}/${USERID}`,
        loginData?.accessToken
      );

      const [announcementsRes, notifications] = await Promise.all([
        announcementsPromise,
        notificationsPromise
      ]);

      if (announcementsRes?.data?.data) {
        setAnnouncements(announcementsRes.data.data);
      } else {
        setAnnouncements(null);
      }

      if (notifications?.data) {
        const notificationData = notifications?.data?.data || [];
        const newContactInvitations = notificationData?.filter(
          (dash) => dash.title === "Contact Invitation"
        );
        setContactInvitations(newContactInvitations);
        const newDashboardNotifications = notificationData?.filter(
          (dash) => dash.title !== "Contact Invitation" && dash.title !== "BadgeNotifications"
        );
        const weekLY = newDashboardNotifications?.filter(
          (dash) => dash?.title === "Weekly Summary Notification"
        );
        setWeeklyData(weekLY);
        const sortedNotifications = newDashboardNotifications?.filter(
          (dash) => dash.title !== "Weekly Summary Notification"
        );
        setUserNotification(sortedNotifications);
      } else {
        setUserNotification([]);
        setWeeklyData([]);
        setContactInvitations([]);
      }
    } catch (err) {
      console.log("getData-> Error While Getting Dashboard Notification: ", err);
    } finally {
      if (showLoading) setIsLoading(false);
    }
  };

  const updateData = async () => {
    try {
      await Getrequestcall(`${GET_DASHBOARD_NOTIFICATION}/${USERID}/true`, loginData?.accessToken);
      dispatch(setMainNotification(0));
    } catch (err) {
      console.log("updateData-> Error While Getting Dashboard Notification: ", err);
    }
  };

  const createDismissPayload = (ids) => ({
    UserId: Number(USERID),
    ReturnRecordId: false,
    ReturnRecordError: true,
    SoftDelete: true,
    DeleteList: ids.map((id) => ({ id }))
  });

  const dismissNotifications = async (ids) => {
    const normalizedIds = [
      ...new Set((ids || []).map((id) => Number(id)).filter((id) => id !== 0))
    ];
    if (!normalizedIds.length) return;

    try {
      setActionLoadingId(normalizedIds.length > 1 ? "all" : normalizedIds[0]);
      await Postrequestcall(
        DELETE_USER_NOTIFICATIONS,
        createDismissPayload(normalizedIds),
        loginData?.accessToken
      );
      await getData(false);
      dispatch(setMainNotification(0));
    } catch (err) {
      console.log("dismissNotifications-> Error While Dismissing Notifications:", err);
    } finally {
      setActionLoadingId(null);
    }
  };

  const renderDismissButton = (dismissId) =>
    dismissId !== 0 ? (
      <IconButton
        size="small"
        aria-label={TEXT_DISMISS}
        onClick={() => openDismissConfirmation([dismissId])}
        disabled={actionLoadingId === dismissId}
        sx={{
          border: "1px solid rgba(148,163,184,0.35)",
          color: "#475569",
          bgcolor: "#fff",
          "&:hover": {
            bgcolor: "#fff",
            borderColor: "#cbd5e1"
          }
        }}>
        <DeleteOutline fontSize="small" />
      </IconButton>
    ) : null;

  const renderDismissAction = (dismissId) => {
    if (dismissId === 0) return null;
    if (actionLoadingId === dismissId) {
      return <CircularProgress size={18} thickness={5} sx={{ color: "#64748b" }} />;
    }
    return renderDismissButton(dismissId);
  };

  const handelNotificationAcceptORCancle = async (contactUserId, val) => {
    try {
      setActionLoadingId(contactUserId);
      const obj = {
        Id: 0,
        UserId: contactUserId,
        ContactEmail: loginData?.userInformation?.Email,
        EventStatusId: val,
        ModifiedBy: loginData?.userInformation?.UserId
      };
      await Postrequestcall(SAVECONTACTEVENT, obj, loginData?.accessToken);
      await getData();
      if (location.pathname.includes("contacts")) {
        window.dispatchEvent(new Event("REFRESH_BUILDER_NETWORK"));
      }
    } finally {
      setActionLoadingId(null);
    }
  };

  const getNotificationIcon = (item) => {
    switch (item?.title) {
      case "Expired Tickets":
      case "Shared Tickets":
        return <CreditCard fontSize="medium" color="primary" />;
      case "Earn BuilderBucks":
        return <Redeem fontSize="medium" color="primary" />;
      case "Ride Share":
        return <DirectionsCar fontSize="medium" color="primary" />;
      case "Contact Invitation":
        return <Avatar alt="Contact Profile" src={item?.custom3} />;
      case "Channel Join Request":
        return <Person fontSize="medium" color="primary" />;
      case "Weekly Summary Notification":
        return <ListIcon fontSize="medium" color="primary" />;
      default:
        return <Avatar alt="Remy Sharp" src={AvtarImage} />;
    }
  };

  const boldTextFromApi = (text) => {
    const parts = text?.split(/<([^>]+)>/);
    const styledText = parts?.map((part, index) => {
      if (index % 2 === 1) {
        return (
          <span key={index} style={{ fontWeight: "bold" }}>
            {part}
          </span>
        );
      }
      return <span key={index}>{part}</span>;
    });
    return <span>{styledText}</span>;
  };

  const getNotificationDate = (date) => {
    if (!moment.isMoment(date)) date = moment(date);
    if (date.isSame(moment(), "day")) {
      return moment.parseZone(date).local().fromNow(true);
    } else if (date.isSame(moment().subtract(1, "d"), "day")) {
      return "1 d";
    } else if (date.isSame(moment().subtract(2, "d"), "day")) {
      return "2 d";
    } else if (date.isSame(moment().subtract(3, "d"), "day")) {
      return "3 d";
    } else if (date.isSame(moment().subtract(4, "d"), "day")) {
      return "4 d";
    } else if (date.isSame(moment().subtract(5, "d"), "day")) {
      return "5 d";
    } else if (date.isSame(moment().subtract(6, "d"), "day")) {
      return "6 d";
    } else if (date.isSame(moment(), "week")) {
      return moment.parseZone(date).local().format("dddd");
    }
    return moment.parseZone(date).local().format("MMMM D, YYYY");
  };

  const getNotifyPrimaryText = (data) => {
    if (data?.title === "Contact Invitation") {
      return (
        <Typography variant="body1" fontWeight={700} noWrap>
          {data?.custom2}
        </Typography>
      );
    }
    return (
      <Typography variant="body1" sx={{ wordBreak: "break-word" }}>
        {boldTextFromApi(data?.description)}
      </Typography>
    );
  };

  const getNotifyPrimarySecondary = (data) => {
    if (data?.title === "Contact Invitation") {
      return (
        <Typography color="text.secondary" variant="body2" noWrap>
          {data?.custom4}
        </Typography>
      );
    }

    if (data?.title === "Weekly Summary Notification") {
      return null;
    }

    return (
      <Typography color="text.secondary" variant="body2" sx={{ wordBreak: "break-word" }}>
        {getNotificationDate(data?.notificationDate)}
      </Typography>
    );
  };

  const renderWeeklySummaryStats = (data) => {
    const weeklySummaryArray = [
      {
        label: TEXT_POINTS_GAINED,
        value: data?.custom5,
        icon: <WorkspacePremiumOutlined fontSize="small" />
      },
      {
        label: TEXT_PROJECTS_ADDED,
        value: data?.custom1,
        icon: <AssignmentTurnedInOutlined fontSize="small" />
      },
      {
        label: TEXT_PRODUCTS_ADDED,
        value: data?.custom4,
        icon: <Inventory2Outlined fontSize="small" />
      },
      {
        label: TEXT_QUESTIONS_ANS,
        value: data?.custom2,
        icon: <HelpOutline fontSize="small" />
      },
      {
        label: TEXT_NUMBER_OF_VIEWS_PROFILE,
        value: data?.custom3,
        icon: <VisibilityOutlined fontSize="small" />
      }
    ];

    return (
      <Stack spacing={1} sx={{ mt: 1.25 }}>
        <Card
          variant="outlined"
          sx={{
            borderRadius: 2,
            borderColor: "#f3d08a",
            background: "linear-gradient(180deg, #fff0c9 0%, #fff9e7 100%)",
            boxShadow: "none"
          }}>
          <CardContent sx={{ p: 1.4, "&:last-child": { pb: 1.4 } }}>
            <Stack direction="row" alignItems="center" spacing={1.25}>
              <Box sx={{ color: "#b45309", display: "flex", alignItems: "center" }}>
                {weeklySummaryArray[0]?.icon}
              </Box>
              <Box sx={{ minWidth: 0 }}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ display: "block", mb: 0.25 }}>
                  {weeklySummaryArray[0]?.label}
                </Typography>
                <Typography variant="h5" fontWeight={800} sx={{ lineHeight: 1, color: "#111827" }}>
                  {weeklySummaryArray[0]?.value}
                </Typography>
              </Box>
            </Stack>
          </CardContent>
        </Card>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            gap: 1
          }}>
          {weeklySummaryArray.slice(1).map((item, index) => (
            <Card
              key={`${item.label}-${index}`}
              variant="outlined"
              sx={{
                borderRadius: 2,
                borderColor: "#f3d08a",
                backgroundColor: "#fff",
                boxShadow: "none"
              }}>
              <CardContent sx={{ p: 1.15, "&:last-child": { pb: 1.15 } }}>
                <Stack direction="row" spacing={1.25} alignItems="flex-start">
                  <Box
                    sx={{
                      width: 30,
                      height: 30,
                      mt: 0.2,
                      borderRadius: "50%",
                      bgcolor: "rgba(180,83,9,0.1)",
                      color: "#b45309",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0
                    }}>
                    {item.icon}
                  </Box>
                  <Box sx={{ minWidth: 0, pt: 0.2 }}>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ display: "block", lineHeight: 1.2, mb: 0.5 }}>
                      {item.label}
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      fontWeight={800}
                      sx={{ lineHeight: 1.1, color: "#111827" }}>
                      {item.value}
                    </Typography>
                  </Box>
                </Stack>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Stack>
    );
  };

  const notificationCardSx = {
    borderRadius: 3,
    overflow: "hidden",
    borderColor: "#ececec",
    backgroundColor: "#fff",
    transition: "transform 0.16s ease, box-shadow 0.16s ease, border-color 0.16s ease",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 10px 24px rgba(15, 23, 42, 0.08)"
    }
  };

  const NotificationList = ({ setMenView, handelNotificationAcceptORCancle: onContactAction }) => {
    const handleNotificationClick = (item) => {
      switch (item.title) {
        case "Post Comment":
          navigate("/community", {
            state: {
              item,
              from: "from-notification"
            }
          });
          setMenView(false);
          break;
        case "Tickets":
          navigate("/tickets", { ticketType: "valid", refresh: new Date() });
          setMenView(false);
          break;
        case "Contact Invitation Accepted":
        case "Contact Invitation":
          navigate(`/${item?.custom1}`);
          setMenView(false);
          break;
        case "BuildID Info":
          navigate("/dashboard", { refresh: new Date() });
          setMenView(false);
          break;
        case "Ride Share":
          navigate("/carpool");
          setMenView(false);
          break;
        case "Expired Tickets":
          navigate("/tickets", {
            ticketType: "expired",
            refresh: new Date()
          });
          setMenView(false);
          break;
        case "Shared Tickets":
          navigate("/tickets", { ticketType: "shared", refresh: new Date() });
          setMenView(false);
          break;
        case "BuilderBucks":
          setMenView(false);
          break;
        case "New Job Posting":
          navigate(`/project/${item?.recordId}`, {
            from: "DashboardNotifications"
          });
          setMenView(false);
          break;
        case "Job Posting Expired":
          navigate("/job-postings", {
            jobPostType: "jobPostExpired",
            refresh: new Date()
          });
          setMenView(false);
          break;
        case "Job Posting Expire 3 Days":
          navigate("/job-postings", {
            jobPostType: "jobPostActive",
            refresh: new Date()
          });
          setMenView(false);
          break;
        case "Post Projects":
          navigate(`/project/${item?.recordId}`, {
            from: "DashboardNotifications"
          });
          setMenView(false);
          break;
        default:
          break;
      }
    };

    const handleTicketRequest = async (item, action) => {
      try {
        const payload = {
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: [
            {
              Id: Number(item?.custom4),
              Status: action,
              ValidUntil: action === "Accepted" ? moment.utc().add(16, "hours").toISOString() : ""
            }
          ],
          UserId: Number(loginData?.userInformation?.UserId)
        };
        console.log("payload", payload);
        await Postrequestcall(SAVE_TICKETS_SHARED_WITH_SUPERVISOR, payload, loginData?.accessToken);
        await getData();
      } catch (err) {
        console.log("Error while handling ticket request");
      }
    };

    const sectionLabelSx = {
      px: 0.5,
      display: "block",
      mb: 0.75,
      letterSpacing: 1,
      fontSize: 11,
      fontWeight: 800
    };

    return (
      <Box>
        <ListSubheader
          disableSticky
          sx={{
            bgcolor: "#0f172a",
            color: "#fff",
            py: 1.5,
            px: 2,
            lineHeight: 1.2,
            borderBottom: "1px solid rgba(255,255,255,0.08)"
          }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2}>
            <Box sx={{ minWidth: 0 }}>
              <Typography variant="subtitle1" fontWeight={800} sx={{ color: "#fff" }}>
                {TEXT_NOTIFICATIONS}
              </Typography>
            </Box>

            {hasDismissableNotifications && (
              <Stack direction="row" alignItems="center" spacing={1}>
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={
                    isDismissingAll ? (
                      <CircularProgress size={14} thickness={5} sx={{ color: "inherit" }} />
                    ) : (
                      <DeleteOutline fontSize="small" />
                    )
                  }
                  onClick={() => {
                    if (!isDismissingAll) openDismissConfirmation(dismissableNotificationIds);
                  }}
                  disabled={isDismissingAll}
                  sx={{
                    minWidth: "auto",
                    borderRadius: 999,
                    px: 1.5,
                    borderColor: "rgba(59,130,246,0.32)",
                    color: "white",
                    backgroundColor: "rgba(59,130,246,0.1)",
                    "&:hover": {
                      bgcolor: "rgba(59,130,246,0.18)",
                      borderColor: "rgba(59, 131, 246, 0.51)"
                    },
                    "&.Mui-disabled": {
                      color: "#e0f2fe",
                      borderColor: "rgba(59,130,246,0.24)",
                      backgroundColor: "rgba(59,130,246,0.14)",
                      opacity: 1,
                      pointerEvents: "none"
                    }
                  }}>
                  {isDismissingAll ? "Dismissing..." : TEXT_DISMISS_ALL}
                </Button>
              </Stack>
            )}
          </Stack>
        </ListSubheader>

        <Stack
          gap={1.25}
          p={1.5}
          sx={{ background: "linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)" }}>
          {contactInvitations.length > 0 && (
            <Box>
              <Typography variant="overline" color="text.secondary" sx={sectionLabelSx}>
                {TEXT_CONTACT_REQUESTS}
              </Typography>
              <Stack gap={1}>
                {contactInvitations.map((data, index) => {
                  const dismissId = Number(data?.userNotificationsDismissalId || 0);
                  return (
                    <Card
                      key={`contact-${data?.id || index}`}
                      variant="outlined"
                      sx={notificationCardSx}>
                      <ListItem sx={{ m: 0, p: 0 }} disablePadding>
                        <ListItemButton
                          sx={{
                            m: 0,
                            p: 1.5,
                            pl: 1.5,
                            pr: 1.5,
                            alignItems: "flex-start",
                            "&:hover": {
                              backgroundColor: "rgba(59,130,246,0.04)"
                            }
                          }}
                          onClick={() => handleNotificationClick(data)}>
                          <ListItemIcon sx={{ minWidth: 44, mt: 0.5 }}>
                            {getNotificationIcon(data)}
                          </ListItemIcon>
                          <Box sx={{ flex: 1, minWidth: 0, pr: 2 }}>
                            {getNotifyPrimaryText(data)}
                            {getNotifyPrimarySecondary(data)}
                          </Box>
                        </ListItemButton>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            pr: 1.5,
                            flexShrink: 0,
                            alignSelf: "stretch",
                            borderLeft: "1px solid rgba(226,232,240,0.9)",
                            bgcolor: "#fff"
                          }}>
                          <Button
                            color="primary"
                            size="small"
                            variant="contained"
                            onClick={() => onContactAction(data.custom1, 2)}
                            disabled={actionLoadingId === data.custom1}>
                            {TEXT_ACCEPT}
                          </Button>
                          {dismissId !== 0 && (
                            <IconButton
                              size="small"
                              aria-label={TEXT_DISMISS}
                              onClick={() => onContactAction(data.custom1, 3)}
                              disabled={actionLoadingId === data.custom1}
                              sx={{
                                border: "1px solid #cbd5e1",
                                color: "#475569",
                                bgcolor: "#fff",
                                "&:hover": {
                                  borderColor: "#94a3b8",
                                  backgroundColor: "#f8fafc"
                                }
                              }}>
                              <Close fontSize="small" />
                            </IconButton>
                          )}
                        </Box>
                      </ListItem>
                    </Card>
                  );
                })}
              </Stack>
            </Box>
          )}

          {ticketRequests.length > 0 && (
            <Box>
              <Typography variant="overline" color="text.secondary" sx={sectionLabelSx}>
                Ticket Requests
              </Typography>
              <Stack gap={1}>
                {ticketRequests.map((data, index) => {
                  const dismissId = Number(data?.userNotificationsDismissalId || 0);
                  return (
                    <Card
                      key={`ticket-request-${data?.id || index}`}
                      variant="outlined"
                      sx={{
                        ...notificationCardSx,
                        borderColor: "#e2e8f0",
                        background: "#fff",
                        opacity: actionLoadingId === dismissId ? 0.7 : 1
                      }}>
                      <ListItem sx={{ m: 0, p: 0 }} disablePadding>
                        <ListItemButton
                          sx={{
                            m: 0,
                            p: 1.5,
                            pl: 1.5,
                            pr: 1.5,
                            alignItems: "flex-start",
                            flex: 1,
                            color: "inherit",
                            "&:hover": {
                              backgroundColor: "rgba(59,130,246,0.04)"
                            }
                          }}
                          onClick={() => handleNotificationClick(data)}>
                          <ListItemIcon sx={{ minWidth: 44, mt: 0.5 }}>
                            {getNotificationIcon(data)}
                          </ListItemIcon>
                          <Box sx={{ flex: 1, minWidth: 0, pr: 2 }}>
                            {getNotifyPrimaryText(data)}
                            {getNotifyPrimarySecondary(data)}
                          </Box>
                        </ListItemButton>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            pr: 2
                          }}>
                          {data?.custom5 === "Accepted" ? (
                            <Chip
                              label="Accepted"
                              size="small"
                              sx={{
                                borderRadius: "20px",
                                bgcolor: "#DCFCE7",
                                color: "#15803D",
                                fontWeight: 600
                              }}
                            />
                          ) : data?.custom5 === "Rejected" ? (
                            <Chip
                              label="Rejected"
                              size="small"
                              sx={{
                                borderRadius: "20px",
                                bgcolor: "#FDECEC",
                                color: "#DC2626",
                                fontWeight: 600
                              }}
                            />
                          ) : (
                            <>
                              <IconButton
                                sx={{
                                  width: 35,
                                  height: 35,
                                  bgcolor: "#FDECEC",
                                  "&:hover": {
                                    bgcolor: "#FADADA"
                                  }
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleTicketRequest(data, "Rejected");
                                }}>
                                <CloseIcon sx={{ color: "#DC2626" }} />
                              </IconButton>
                              <IconButton
                                sx={{
                                  width: 35,
                                  height: 35,
                                  bgcolor: "#DCFCE7",
                                  "&:hover": {
                                    bgcolor: "#C8F5D4"
                                  }
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleTicketRequest(data, "Accepted");
                                }}>
                                <CheckIcon sx={{ color: "#16A34A" }} />
                              </IconButton>
                            </>
                          )}
                        </Box>
                      </ListItem>
                    </Card>
                  );
                })}
              </Stack>
            </Box>
          )}

          {weeklyData.length > 0 && (
            <Box>
              <Typography variant="overline" color="text.secondary" sx={sectionLabelSx}>
                {TEXT_WEEKLY_SUMMARY}
              </Typography>
              <Stack gap={1}>
                {weeklyData.map((data, index) => {
                  return (
                    <Card
                      key={`weekly-${data?.id || index}`}
                      variant="outlined"
                      sx={{
                        ...notificationCardSx,
                        borderColor: "#f3d08a",
                        background: "linear-gradient(180deg, #fff6db 0%, #fffdf6 100%)"
                      }}>
                      <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
                        <Box sx={{ p: 1.5 }}>
                          <Stack direction="row" alignItems="center" gap={1.5}>
                            <Box sx={{ color: "#b45309", display: "flex", alignItems: "center" }}>
                              {getNotificationIcon(data)}
                            </Box>
                            <Typography
                              variant="body1"
                              fontWeight={700}
                              sx={{ wordBreak: "break-word", color: "#111827" }}>
                              {getNotifyPrimaryText(data)}
                            </Typography>
                          </Stack>
                          <Box sx={{ mt: 1.5 }}>{renderWeeklySummaryStats(data)}</Box>
                        </Box>
                      </CardContent>
                    </Card>
                  );
                })}
              </Stack>
            </Box>
          )}

          {announcements && (Array.isArray(announcements) ? announcements : [announcements]).length > 0 && (
            <Box>
              <Stack gap={1}>
                {(Array.isArray(announcements) ? announcements : [announcements]).map((ann, index) => {
                  if (!ann) return null;
                  const getContrastColor = (hexcolor) => {
                    if (!hexcolor || hexcolor.toLowerCase() === 'white' || hexcolor.toLowerCase() === '#ffffff') return 'black';
                    if (hexcolor.toLowerCase() === 'black' || hexcolor.toLowerCase() === '#000000') return 'white';
                    
                    if (hexcolor.startsWith('#')) {
                      let hex = hexcolor.replace('#', '');
                      if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                      if (hex.length === 6) {
                        const r = parseInt(hex.substr(0, 2), 16);
                        const g = parseInt(hex.substr(2, 2), 16);
                        const b = parseInt(hex.substr(4, 2), 16);
                        const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
                        return (yiq >= 128) ? 'black' : 'white';
                      }
                    }
                    return 'inherit';
                  };
                  
                  let bgColor = ann.color || '#FCEAB8';
                  let textColor = getContrastColor(bgColor);

                  return (
                    <Card
                      key={`announcement-${ann.id || index}`}
                      variant="outlined"
                      onClick={() => {
                        setSelectedAnnouncement(ann);
                        setOpenPostCommentModalWithSource(true);
                      }}
                      sx={{
                        ...notificationCardSx,
                        backgroundColor: bgColor,
                        borderColor: '#e2e8f0',
                        cursor: 'pointer',
                        borderRadius: 2
                      }}
                    >
                      <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                        <Stack direction="row" spacing={1.5} alignItems="center" mb={1.5}>
                          <Avatar 
                            src={ann.postedByPictureUrl || AvtarImage}
                            sx={{ width: 48, height: 48 }}
                          />
                          <Stack>
                            <Stack direction="row" alignItems="center" spacing={0.5}>
                              <Campaign sx={{ fontSize: 18, color: textColor }} />
                              <Typography variant="body1" fontWeight={700} sx={{ color: textColor }}>
                                Announcement
                              </Typography>
                            </Stack>
                            <Typography variant="body2" sx={{ color: textColor, opacity: 0.9 }}>
                              {ann.appRecordName || `${ann.postedByFirstName || ''} ${ann.postedByLastName || ''}`.trim() || 'My BuilderID'}
                            </Typography>
                          </Stack>
                        </Stack>

                        <Divider sx={{ borderColor: textColor === 'white' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)', mb: 1.5 }} />

                        <Typography 
                          variant="body2" 
                          sx={{ 
                            color: textColor, 
                            opacity: 0.9,
                            display: '-webkit-box',
                            WebkitLineClamp: 5,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            mb: 2
                          }}
                        >
                          {ann.message || ann.title || ann.description}
                        </Typography>

                        <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={0.5}>
                          <Typography variant="subtitle2" fontWeight={700} sx={{ color: textColor }}>
                            View Details
                          </Typography>
                          <ArrowForward sx={{ fontSize: 16, color: textColor }} />
                        </Stack>
                      </CardContent>
                    </Card>
                  );
                })}
              </Stack>
            </Box>
          )}

          {builderBucksNotifications.length > 0 && (
            <Box>
              <Typography variant="overline" color="text.secondary" sx={sectionLabelSx}>
                {TEXT_BUILDER_BUCKS}
              </Typography>
              <Stack gap={1}>
                {builderBucksNotifications.map((data, index) => {
                  const dismissId = Number(data?.userNotificationsDismissalId || 0);
                  return (
                    <Card
                      key={`builderbucks-${data?.id || index}`}
                      variant="outlined"
                      sx={{
                        ...notificationCardSx,
                        borderColor: "#ffe08a",
                        background: "linear-gradient(180deg, #fff8e1 0%, #fffdf7 100%)",
                        opacity: actionLoadingId === dismissId ? 0.7 : 1
                      }}>
                      <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
                        <Stack direction="row" alignItems="flex-start" gap={1.5} sx={{ p: 1.5 }}>
                          <Avatar
                            sx={{ bgcolor: "#f7c948", color: "#6b4e00", width: 40, height: 40 }}>
                            <Redeem fontSize="small" />
                          </Avatar>
                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography
                              variant="body1"
                              fontWeight={700}
                              sx={{ wordBreak: "break-word" }}>
                              {getNotifyPrimaryText(data)}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                              {getNotificationDate(data?.notificationDate)}
                            </Typography>
                          </Box>
                          {dismissId !== 0 && (
                            <Box
                              sx={{
                                width: 64,
                                alignSelf: "stretch",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                pr: 1,
                                borderLeft: "1px solid rgba(226,232,240,0.9)",
                                bgcolor: "transparent",
                                transition: "background-color 0.16s ease",
                                "&:hover": {
                                  bgcolor: "#e5e7eb"
                                }
                              }}>
                              {renderDismissAction(dismissId)}
                            </Box>
                          )}
                        </Stack>
                      </CardContent>
                    </Card>
                  );
                })}
              </Stack>
            </Box>
          )}
          {nonTicketRegularNotifications.length > 0 && (
            <Box>
              <Stack gap={1}>
                {nonTicketRegularNotifications.map((data, index) => {
                  const dismissId = Number(data?.userNotificationsDismissalId || 0);
                  return (
                    <Card
                      key={`notification-${data?.id || index}`}
                      variant="outlined"
                      sx={{
                        ...notificationCardSx,
                        display: "flex",
                        alignItems: "stretch",
                        borderColor: "#e2e8f0",
                        background: "#fff",
                        opacity: actionLoadingId === dismissId ? 0.7 : 1
                      }}>
                      <ListItem sx={{ m: 0, p: 0 }} disablePadding>
                        <ListItemButton
                          sx={{
                            m: 0,
                            p: 1.5,
                            pl: 1.5,
                            pr: 1.5,
                            alignItems: "flex-start",
                            flex: 1,
                            color: "inherit",
                            "&:hover": {
                              backgroundColor: "rgba(59,130,246,0.04)"
                            }
                          }}
                          onClick={() => handleNotificationClick(data)}>
                          <ListItemIcon sx={{ minWidth: 44, mt: 0.5 }}>
                            {getNotificationIcon(data)}
                          </ListItemIcon>
                          <Box sx={{ flex: 1, minWidth: 0, pr: 2 }}>
                            {getNotifyPrimaryText(data)}
                            {getNotifyPrimarySecondary(data)}
                          </Box>
                        </ListItemButton>
                        {data?.title === "VIEW_TICKET_REQUEST" ? (
                          data?.custom5 === "Accepted" ? (
                            <Chip
                              label="Accepted"
                              size="small"
                              sx={{
                                mr: 2,
                                borderRadius: "20px",
                                bgcolor: "#DCFCE7",
                                color: "#15803D",
                                fontWeight: 600
                              }}
                            />
                          ) : data?.custom5 === "Rejected" ? (
                            <Chip
                              label="Rejected"
                              size="small"
                              sx={{
                                mr: 2,
                                borderRadius: "20px",
                                bgcolor: "#FDECEC",
                                color: "#DC2626",
                                fontWeight: 600
                              }}
                            />
                          ) : (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                pr: 2
                              }}>
                              <IconButton
                                sx={{
                                  width: 35,
                                  height: 35,
                                  bgcolor: "#FDECEC",
                                  "&:hover": {
                                    bgcolor: "#FADADA"
                                  }
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleTicketRequest(data, "Rejected");
                                }}>
                                <CloseIcon sx={{ color: "#DC2626" }} />
                              </IconButton>
                              <IconButton
                                sx={{
                                  width: 35,
                                  height: 35,
                                  bgcolor: "#DCFCE7",
                                  "&:hover": {
                                    bgcolor: "#C8F5D4"
                                  }
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleTicketRequest(data, "Accepted");
                                }}>
                                <CheckIcon sx={{ color: "#16A34A" }} />
                              </IconButton>
                            </Box>
                          )
                        ) : (
                          dismissId !== 0 && (
                            <Box
                              sx={{
                                width: 64,
                                alignSelf: "stretch",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                pr: 1,
                                borderLeft: "1px solid rgba(226,232,240,0.9)",
                                bgcolor: "transparent",
                                transition: "background-color 0.16s ease",
                                "&:hover": {
                                  bgcolor: "#e5e7eb"
                                }
                              }}>
                              {renderDismissAction(dismissId)}
                            </Box>
                          )
                        )}
                      </ListItem>
                    </Card>
                  );
                })}
              </Stack>
            </Box>
          )}

          {contactInvitations.length === 0 &&
            weeklyData.length === 0 &&
            builderBucksNotifications.length === 0 &&
            regularNotifications.length === 0 &&
            (!announcements || (Array.isArray(announcements) ? announcements : [announcements]).length === 0) && (
              <Card
                variant="outlined"
                sx={{
                  borderRadius: 3,
                  background:
                    "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(248,250,252,1) 100%)",
                  borderColor: "#e2e8f0"
                }}>
                <CardContent sx={{ py: 4, textAlign: "center" }}>
                  <Stack alignItems="center" spacing={1.25}>
                    <Avatar sx={{ bgcolor: "#e2e8f0", color: "#475569", width: 48, height: 48 }}>
                      <NotificationsNoneOutlined />
                    </Avatar>
                    <Typography variant="body2" color="text.secondary">
                      {TEXT_NO_NOTIFICATIONS}
                    </Typography>
                  </Stack>
                </CardContent>
              </Card>
            )}
        </Stack>
      </Box>
    );
  };

  useEffect(() => {
    if (menuView) getData();
  }, [menuView]);

  return (
    <Menu
      anchorEl={anchorEl}
      id="account-menu"
      open={menuView}
      onClose={() => {
        updateData();
        setMenView(false);
      }}
      sx={{
        borderRadius: "10px",
        p: 0,
        mt: 1.5,
        "& .MuiPaper-root": {
          borderRadius: 4,
          overflow: "hidden"
        },
        "& .MuiList-root": {
          padding: "0px",
          width: "410px",
          maxHeight: "74vh",
          overflowY: "auto",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          "&::-webkit-scrollbar": {
            display: "none"
          }
        }
      }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}>
      {isLoading ? (
        <Box width={"410px"} sx={{ p: 1.5 }}>
          {[...Array(6)].map((data, index) => (
            <Stack key={index.toString()} width={"100%"} sx={{ mb: 1.5 }}>
              <CardHeader
                sx={{ pt: 1, pb: 1 }}
                avatar={<Skeleton animation="wave" variant="circular" width={40} height={40} />}
                title={
                  <Skeleton animation="wave" height={10} width="100%" style={{ marginBottom: 5 }} />
                }
                subheader={<Skeleton animation="wave" height={10} width="50%" />}
              />
            </Stack>
          ))}
        </Box>
      ) : (
        <NotificationList
          setMenView={setMenView}
          handelNotificationAcceptORCancle={handelNotificationAcceptORCancle}
        />
      )}
      <Dialog
        open={confirmDismissOpen}
        onClose={closeDismissConfirmation}
        PaperProps={{
          sx: {
            borderRadius: 3,
            width: "100%"
          }
        }}>
        <DialogTitle sx={{ fontWeight: 800 }}>Confirm dismissal</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ color: "text.secondary" }}>
            {pendingDismissIds.length > 1
              ? "Do you want to dismiss all selected notifications?"
              : "Do you want to dismiss this notification?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={closeDismissConfirmation} disabled={Boolean(actionLoadingId)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={confirmDismissNotifications}
            disabled={Boolean(actionLoadingId)}
            startIcon={
              actionLoadingId ? (
                <CircularProgress size={14} thickness={5} sx={{ color: "inherit" }} />
              ) : null
            }>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      {openPostCommentModalWithSource && (
        <PostComment
          open={openPostCommentModalWithSource}
          onClose={() => setOpenPostCommentModalWithSource(false)}
          from="new-dashboard"
          postItem={selectedAnnouncement}
        />
      )}
    </Menu>
  );
}

export default NotificationsMenu;
